// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5a34d107","703":"8dc19e5b","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};